<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'SupplierList' }">Suppliers</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form 
     ref="supplier" 
     :model="supplier"
     :rules="rules.supplier"
     :label-position="label_position">
    
      <el-form-item label="Name" prop="name">
          <el-input v-model="supplier.name"></el-input>
      </el-form-item>

      <el-form-item label="Code" prop="code">
          <el-input v-model="supplier.code" disabled></el-input>
      </el-form-item>

      <el-form-item label="Order Notification E-Mail" prop="order_notification_email">
          <el-input v-model="supplier.order_notification_email"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="updateSupplier('supplier')">Update</el-button>
      </el-form-item>
    </el-form>

    <pre>{{$data}}</pre>
  </div>
</template>

<style>
</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';

  export default {
    data: function() {
      return{
        config: Config.config,
        page_alias: 'Edit Supplier',
        page_slug: 'edit-supplier',
        label_position: 'top',
        
        rules:{
          supplier:{
            name: [
              { required: true, message: 'Please Enter Name', trigger: 'blur' }
            ],

            order_notification_email: [
              { required: true, message: 'Please Enter Order Notification E-Mail', trigger: 'blur' },
              { type: 'email', message: 'Please Enter Valid E-Mail', trigger: 'blur'}
            ],
          }
        },
  
        supplier:{
          name:'',
          order_notification_email:'',
          updated_user_id: ''
        }
      };
    },

    mounted: function() {
      const me = this;
      me.getSupplier();
    },

    methods: {
      getSupplier: function() {
        console.log('get supplier function');
        const me = this;
        me.$http.get(me.config.api + 'supplier/{id}', {params: {id : me.$route.params.id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.supplier = response.body.data;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
        });
      },

      updateSupplier: function(formName) {
        console.log('get supplier function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            var jwt = Utils.decodejwt();
            me.supplier.updated_user_id = jwt.sub;
            me.$http.put(me.config.api + 'supplier/{id}', me.supplier, {params: {id : me.$route.params.id}}).then(
            response => {
              console.log('success putting data')  
              console.log(response.status);
              console.log(response.statusText);

              me.getSupplier();

              me.$notify({
                title: 'Success',
                message: 'The Supplier Was Updated',
                type: 'success',
              });
            }, response => {
              console.log('Error Getting Data');
              console.log(response.status);
              console.log(response.statusText);
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/pages/suppliers/SupplierEdit.vue